<template>
	<ViewPhoto
		:key="photosIndex"
		v-if="imageShow && photos.length"
		:images="photos"
		:index="photosIndex"
		@close="imageShow = false"
	/>
	<DaModalFrame v-model:open="modalIsOpen">
		<CopyModal v-model:path="path" @close="closeShare" />
	</DaModalFrame>
	<div>
		<div
			v-if="!isLoading"
			class="__report-student pb-30 px-10 md-down:px-4"
		>
			<div class="pt-10">
				<div class="flex items-center justify-between">
					<div
						class="__breadcrumbs text-sm text-neutral-500 font-semibold flex-nowrap flex items-center"
					>
						<router-link
							:to="{
								path: is_old_data
									? '/transferred-data'
									: '/report/day-care',
							}"
						>
							{{
								is_old_data
									? 'Xem hồ sơ cũ'
									: 'Danh sách học sinh'
							}}
						</router-link>
						<div class="__breadcrumbs__decorate">
							<DaIcon
								class="transform -rotate-90 h-3 w-3 mx-2"
								name="das--chevron-down"
							/>
						</div>
						<div>Xem báo cáo</div>
					</div>
					<button
						v-if="is_old_data"
						class="button-p text-center w-fit btn--text text-neutral-500 hover:text-neutral-600"
						type="button"
						@click="exit"
					>
						<svg
							class="mr-2 text-neutral-400"
							fill="none"
							height="16"
							viewBox="0 0 16 16"
							width="16"
							xmlns="http://www.w3.org/2000/svg"
						>
							<path
								d="M1.5 7.99996L0.719131 7.37526L0.219375 7.99996L0.719131 8.62465L1.5 7.99996ZM7.5 8.99996C8.05228 8.99996 8.5 8.55224 8.5 7.99996C8.5 7.44767 8.05228 6.99996 7.5 6.99996V8.99996ZM3.3858 4.04193L0.719131 7.37526L2.28087 8.62465L4.94754 5.29132L3.3858 4.04193ZM0.719131 8.62465L3.3858 11.958L4.94754 10.7086L2.28087 7.37526L0.719131 8.62465ZM1.5 8.99996H7.5V6.99996H1.5V8.99996Z"
								fill="currentColor"
							/>
							<path
								d="M7.78738 13.3439L8.31032 12.4915L7.78738 13.3439ZM6.97976 12.3905L6.05301 12.7662L6.97976 12.3905ZM14.499 12.5015L15.3875 12.9603L14.499 12.5015ZM12.7525 13.981L12.4461 13.0291L12.7525 13.981ZM14.499 3.49854L15.3875 3.0398L14.499 3.49854ZM13.8333 6.81921V9.18087H15.8333V6.81921H13.8333ZM7.83325 5.42133V5.29122H5.83325V5.42133H7.83325ZM9.58524 12.7782C8.62733 12.6186 8.43551 12.5683 8.31032 12.4915L7.26445 14.1962C7.80406 14.5273 8.47961 14.6216 9.25644 14.751L9.58524 12.7782ZM5.83325 10.7107C5.83325 11.4979 5.81518 12.1795 6.05301 12.7662L7.90651 12.0148C7.85132 11.8787 7.83325 11.6814 7.83325 10.7107H5.83325ZM8.31032 12.4915C8.12826 12.3798 7.98675 12.2128 7.90651 12.0148L6.05301 12.7662C6.29374 13.36 6.71828 13.8612 7.26445 14.1962L8.31032 12.4915ZM13.8333 9.18087C13.8333 10.0882 13.8325 10.7099 13.7946 11.1876C13.7573 11.6573 13.6894 11.8898 13.6104 12.0428L15.3875 12.9603C15.6428 12.4658 15.742 11.929 15.7883 11.3458C15.834 10.7705 15.8333 10.0557 15.8333 9.18087H13.8333ZM9.25644 14.751C10.1198 14.8949 10.8251 15.0132 11.4002 15.0628C11.9832 15.113 12.5291 15.1035 13.0589 14.9329L12.4461 13.0291C12.2822 13.0819 12.0416 13.1107 11.5719 13.0702C11.0943 13.029 10.4806 12.9275 9.58524 12.7782L9.25644 14.751ZM13.6104 12.0428C13.3679 12.5125 12.9493 12.8671 12.4461 13.0291L13.0589 14.9329C14.0653 14.609 14.9025 13.8997 15.3875 12.9603L13.6104 12.0428ZM9.58645 3.22163C10.4814 3.07248 11.0948 2.97099 11.5722 2.92986C12.0416 2.88942 12.2822 2.91819 12.4461 2.97096L13.0589 1.06717C12.5292 0.896646 11.9834 0.887021 11.4005 0.937243C10.8256 0.986778 10.1206 1.10503 9.25766 1.24885L9.58645 3.22163ZM15.8333 6.81921C15.8333 5.9444 15.834 5.22954 15.7883 4.65428C15.742 4.07104 15.6428 3.53429 15.3875 3.0398L13.6104 3.95728C13.6894 4.1103 13.7573 4.34283 13.7946 4.81252C13.8325 5.29019 13.8333 5.91191 13.8333 6.81921H15.8333ZM12.4461 2.97096C12.9493 3.13294 13.3679 3.48755 13.6104 3.95728L15.3875 3.0398C14.9025 2.10035 14.0653 1.39113 13.0589 1.06717L12.4461 2.97096ZM9.25766 1.24885C8.83685 1.31898 8.47124 1.37935 8.17099 1.45102C7.85987 1.52528 7.55473 1.62545 7.26252 1.80503L8.30967 3.50898C8.35038 3.48397 8.42887 3.44565 8.63532 3.39637C8.85265 3.3445 9.13857 3.29628 9.58645 3.22163L9.25766 1.24885ZM7.83325 5.29122C7.83325 4.83715 7.83381 4.5472 7.84925 4.3243C7.86391 4.11256 7.88881 4.02884 7.90679 3.98457L6.05387 3.23179C5.92477 3.54955 5.87613 3.86701 5.85403 4.1861C5.8327 4.49405 5.83325 4.86461 5.83325 5.29122H7.83325ZM7.26252 1.80503C6.71792 2.13971 6.29446 2.63958 6.05387 3.23179L7.90679 3.98457C7.98699 3.78717 8.12814 3.62054 8.30967 3.50898L7.26252 1.80503Z"
								fill="currentColor"
							/>
						</svg>
						Thoát
					</button>
				</div>
				<div class="__report-student__header pt-5">
					<div class="flex justify-between items-center w-full">
						<router-link :to="`/record/student/${student?.id}`">
							<div class="flex items-center">
								<img
									v-if="student?.profile_photo?.w200"
									:src="student?.profile_photo?.w200"
									alt=""
									class="shadow-sm inline-block h-14 w-14 rounded-full"
								/>
								<span
									v-else
									:style="{
										background:
											student?.profile_photo?.default
												?.color,
									}"
									class="inline-flex items-center justify-center h-14 w-14 rounded-full"
								>
									<span
										class="font-medium leading-none text-white text-4xl"
										>{{
											student?.profile_photo?.default
												?.initial
										}}</span
									>
								</span>
								<div class="ml-4">
									<div
										class="font-bold text-neutral-700 text-4xl md-down:text-2xl"
									>
										{{ student?.name }}
									</div>
									<div
										v-if="is_old_data && dateData"
										class="text-green-500 font-semibold text-xs uppercase letter-spacing-8"
									>
										{{ dateData }}
									</div>
									<div
										v-else-if="student?.age"
										class="text-green-500 font-semibold text-xs uppercase"
									>
										{{ student?.age }}
										{{
											student?.learning_time
												? `| ${student?.learning_time}`
												: ''
										}}
									</div>
								</div>
							</div>
						</router-link>
						<div class="flex space-x-4"></div>
					</div>
				</div>
			</div>
			<!-- -->
			<div class="border-b border-neutral-200 mt-4">
				<nav aria-label="Tabs" class="flex space-x-8 tabs">
					<div
						v-for="(no, index) in dataOfReport"
						:key="index"
						:class="
							tab === index
								? 'border-b-2 text-yellow-700 border-yellow-500'
								: 'text-neutral-500'
						"
						class="order-transparent hover:text-yellow-700 hover:border-yellow-500 whitespace-nowrap pb-6 pt-8 px-1 font-semibold cursor-pointer"
						@click="tab = index"
					>
						{{
							no.key === 'lesson_report'
								? `Học cá nhân ${timeLearning(no.data.session)}`
								: `Học bán trú`
						}}
					</div>
				</nav>
			</div>

			<div v-for="(report, index) in dataOfReport" :key="index">
				<!-- Tab = 0 -->
				<div
					v-if="
						report.key === 'lesson_report' &&
						report.data?.id &&
						tab === index
					"
				>
					<!-- Alert -->
					<div v-if="report.data?.state !== 'completed'" class="mt-8">
						<div
							class="bg-sienna-50 border-l-4 border-sienna-500 p-4 rounded-md"
						>
							<div class="relative text-sm text-gray-600">
								Bạn đang xem bản nháp của báo cáo. Hãy sử dụng
								app {{ $filters.terminology('teacher') }} để
								hoàn thành báo cáo này nhé.
								<br />
								Phụ huynh sẽ không nhận được báo cáo chưa hoàn
								thành
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div
							class="bg-white shadow-sm rounded-2xl overflow-hidden"
						>
							<div
								class="bg-orange-50 p-4 px-6 font-semibold text-lg text-gray-700"
							>
								Báo cáo can thiệp cá nhân
							</div>
							<div
								class="flex items-center justify-between flex-nowrap md-down:flex-col md-down:items-start p-4 px-6"
							>
								<div v-if="report.data?.date">
									{{ $filters.getDay(report.data?.date) }}
									-
									{{
										$filters.formatDate2(report.data?.date)
									}}
								</div>
								<div></div>
							</div>
							<div
								class="flex items-center justify-between flex-nowrap md-down:flex-col md-down:items-start p-4 pt-0 px-6"
							>
								<div v-if="report.data?.date">
									{{
										report.data.session?.display_start_slot
									}}
									<span
										v-if="
											report.data.session
												?.display_end_slot
										"
									>
										-
										{{
											report.data.session
												?.display_end_slot
										}}
									</span>
								</div>
								<router-link
									:to="`/record/student/${report.data?.submitted_by_staff?.id}`"
								>
									<div v-if="report.data?.submitted_by_staff">
										{{ $filters.terminology('teacher') }}
										<span
											class="font-semibold text-blue-700"
											>{{
												report.data?.submitted_by_staff
													?.name
											}}</span
										>
									</div>
								</router-link>
							</div>
						</div>
					</div>
					<div v-if="report.data?.note" class="mt-10">
						<div class="bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 p-6">
								Ghi chú
							</div>
							<div class="p-6 border-t border-orange-100">
								{{ report.data?.note }}
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div class="p-6 bg-white shadow-sm rounded-2xl">
							<div class="font-semibold text-neutral-600 mb-6">
								Thống kê chung
							</div>
							<div class="flex flex-nowrap w-full">
								<div
									class="p-6 border rounded-l-lg border-neutral-200 w-full"
								>
									<div
										class="text-33 font-bold text-neutral-600 mb-6 md-down:text-center flex flex-nowrap items-center"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/abc.png"
											style="height: 32px"
											width="32"
										/>
										{{ count?.skill }}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Tổng số lĩnh vực đã học
										</span>
									</div>
								</div>
								<div
									class="p-6 border rounded-r-lg border-neutral-200 w-full border-l-0"
								>
									<div
										class="text-33 font-bold text-neutral-600 mb-6 md-down:text-center flex flex-nowrap items-center"
									>
										<img
											alt=""
											class="mr-2"
											height="32"
											src="@/assets/images/icons/light.png"
											style="height: 32px"
											width="32"
										/>
										{{ count?.goal }}
									</div>
									<div class="flex flex-nowrap items-center">
										<span class="text-neutral-500 text-sm"
											>Tổng số mục tiêu đã học</span
										>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div class="flex md-down:flex-col">
							<div
								class="bg-white shadow-sm rounded-2xl overflow-hidden w-1/2 mr-8 md-down:mr-0 md-down:w-full md-down:mb-8"
							>
								<div class="font-semibold text-neutral-500 p-6">
									Biểu đồ kết quả mục tiêu đã học
								</div>
								<div
									class="flex flex-nowrap md-down:flex-col p-6 border-t border-orange-50 items-center"
								>
									<div class="relative md-down:mb-8 w-3/5">
										<apexchart
											:options="chartOptions"
											:series="series"
											height="220"
											type="donut"
										></apexchart>
										<div
											class="text-center absolute top-1/2 left-1/2 transform"
											style="
												transform: translate(
													-50%,
													-50%
												);
											"
										>
											<div
												class="text-4xl font-bold text-neutral-600"
											>
												{{ count?.goal }}
											</div>
											<div class="text-neutral-500">
												Mục tiêu
											</div>
										</div>
									</div>
									<div
										class="flex flex-col justify-center md-down:mt-4"
									>
										<div
											v-if="
												assessment_result[0]?.value > 0
											"
											class="flex flex-nowrap items-center mb-4"
										>
											<div
												class="text-sm font-semibold text-neutral-500 w-14 blue"
											>
												{{
													assessment_result[0]?.value
												}}
												M.T
											</div>
											<span
												class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
												style="background: #2aa797"
											>
												{{ assessment_result[0]?.name }}
											</span>
										</div>
										<div
											v-if="
												assessment_result[1]?.value > 0
											"
											class="flex flex-nowrap items-center mb-4"
										>
											<div
												class="text-sm text-neutral-500 w-14 font-semibold"
											>
												{{
													assessment_result[1]?.value
												}}
												M.T
											</div>
											<span
												class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
												style="background: #65a30d"
											>
												{{ assessment_result[1]?.name }}
											</span>
										</div>
										<div
											v-if="
												assessment_result[2]?.value > 0
											"
											class="flex flex-nowrap items-center mb-4"
										>
											<div
												class="text-sm font-semibold text-neutral-500 w-14"
											>
												{{
													assessment_result[2]?.value
												}}
												M.T
											</div>
											<span
												class="flex items-center justify-center py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
												style="background: #f59e0b"
											>
												{{ assessment_result[2]?.name }}
											</span>
										</div>
										<div
											v-if="
												assessment_result[3]?.value > 0
											"
											class="flex flex-nowrap items-center mb-4"
										>
											<div
												class="text-sm font-semibold text-neutral-500 w-14 blue"
											>
												{{
													assessment_result[3]?.value
												}}
												M.T
											</div>
											<span
												class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
												style="background: #f87171"
											>
												{{ assessment_result[3]?.name }}
											</span>
										</div>
										<div
											v-if="
												assessment_result[4]?.value >
													0 ||
												assessment_result[5]?.value >
													0 ||
												assessment_result[6]?.value > 0
											"
											class="flex flex-nowrap items-center mb-4"
										>
											<div
												class="text-sm font-semibold text-neutral-500 w-14 blue"
											>
												{{
													assessment_result[4]
														?.value +
													assessment_result[5]
														?.value +
													assessment_result[6]?.value
												}}
												M.T
											</div>
											<span
												class="flex items-center justify-center px-3 py-0.5 rounded-full text-sm text-white font-semibold w-32 whitespace-nowrap shadow-input"
												style="background: #9ca3af"
											>
												X
											</span>
										</div>
									</div>
								</div>
							</div>
							<div
								class="w-1/2 md-down:w-full flex md-down:flex-col"
							>
								<div
									class="bg-white shadow-sm rounded-2xl w-1/2 md-down:w-full pb-8 mr-8 md-down:mr-0 md-down:mb-8"
								>
									<div
										class="font-semibold text-neutral-500 p-6"
									>
										Mức độ tham gia
									</div>
									<div
										class="p-6 border-t border-orange-100 text-neutral-700 flex items-center flex-col"
									>
										<Rating
											:rating="
												report.data.cooperation_scale ||
												0
											"
											class="max-w-min py-6"
										/>
										<div>
											{{
												$filters.cooperation(
													report.data
														.cooperation_scale +
														'' || '0'
												)
											}}
										</div>
									</div>
								</div>
								<div
									class="bg-white shadow-sm rounded-2xl h-full w-1/2 md-down:w-full"
								>
									<div
										class="font-semibold text-neutral-500 p-6"
									>
										Nhiệt kế cảm xúc
									</div>
									<div
										class="p-6 border-t border-orange-100 text-neutral-700 flex items-center flex-col"
									>
										<div>
											<img
												v-if="report.data.emotion_scale"
												:src="
													require(`@/assets/images/emoji/${
														$filters.emoji(
															report.data
																.emotion_scale +
																''
														).emoji
													}`)
												"
												alt=""
												height="120"
												width="120"
											/>
										</div>
										<div
											v-if="report.data.emotion_scale"
											class="w-full text-center mt-4"
										>
											{{
												$filters.emoji(
													report.data.emotion_scale +
														''
												).message
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
					<div class="mt-10">
						<div class="relative">
							<div
								aria-hidden="true"
								class="absolute inset-0 flex items-center"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div
								class="relative flex justify-center cursor-pointer"
							>
								<div
									class="px-3 bg-body p-2 text-lg font-semibold text-neutral-600 flex items-center"
								>
									<div class="ml-2 text-sm text-neutral-600">
										Kết quả mục tiêu đã học
									</div>
								</div>
							</div>
						</div>
					</div>
					<div>
						<div
							v-for="(ass, index) in report.data
								.assessments_by_skill"
							:key="index"
							class="mt-10"
						>
							<div
								class="font-semibold text-lg text-neutral-600 mb-2"
							>
								{{ index + 1 }}. {{ ass?.skill?.name }}
							</div>
							<div
								class="shadow-sm sm:rounded-2xl overflow-hidden md-down:hidden"
							>
								<div
									class="__record__table overflow-x-auto scroll-bar"
								>
									<div
										class="overflow-hidden sm:rounded-t-2xl w-fit min-w-full"
									>
										<table
											class="min-w-full divide-y text-neutral-200"
										>
											<thead class="bg-neutral-100 h-16">
												<tr>
													<th
														class="px-3 py-3 text-center text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap w-16"
														scope="col"
													>
														STT
													</th>
													<th
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														scope="col"
													>
														Mục Tiêu
													</th>
													<th
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														scope="col"
														style="width: 170px"
													>
														Kết quả
													</th>
													<th
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														scope="col"
														style="width: 300px"
													>
														Hoạt động
													</th>
													<th
														v-if="!isLitePackageValue"
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														scope="col"
														style="width: 100px"
													>
														ALBUM
													</th>
													<th
														class="px-3 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
														scope="col"
														style="width: 250px"
													>
														<div class="w-40">
															Ghi Chú
														</div>
													</th>
												</tr>
											</thead>
											<tbody>
												<tr
													v-for="(
														assessment, index
													) in ass?.assessments"
													:key="assessment.id"
													:class="
														index % 2 === 0
															? 'bg-white'
															: 'bg-neutral-50'
													"
													class="text-neutral-700 hover:bg-orange-50 cursor-pointer"
													@click="
														$router.push(
															`/goal/${student.id}/${assessment.goal_id}`
														)
													"
												>
													<td
														class="px-3 py-4 text-center whitespace-nowrap text-neutral-700"
													>
														<div>
															{{ index + 1 }}
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<div>
															<div
																class="w-96 whitespace-normal"
															>
																{{
																	assessment
																		?.goal
																		?.name
																}}
															</div>
															<template
																v-if="
																	assessment
																		?.goal
																		?.assistance_levels
																"
															>
																<div
																	v-for="ass in assessment
																		?.goal
																		?.assistance_levels"
																	:key="ass"
																>
																	<div
																		class="mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input"
																		style="
																			font-size: 10px;
																		"
																	>
																		{{
																			ass
																		}}
																	</div>
																</div>
															</template>
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<div>
															<div
																:style="{
																	background:
																		$filters.tagResult(
																			assessment?.result
																		)
																			?.background,
																	color: $filters.tagResult(
																		assessment?.result
																	)?.color,
																}"
																class="mt-1 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input"
															>
																{{
																	assessment?.result
																}}
															</div>
														</div>
													</td>
													<td
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<div
															v-if="
																assessment.activities
															"
															class="w-60 whitespace-normal"
														>
															<div
																v-for="a in assessment.activities"
																:key="a.id"
																class="mb-2"
															>
																{{ a.name }}
															</div>
														</div>
													</td>
													<td
														v-if="!isLitePackageValue"
														class="px-3 py-4 whitespace-nowrap text-neutral-700"
													>
														<svg
															v-if="
																haveMedia(
																	report.data
																		.goal_media,
																	assessment
																		?.goal
																		?.id
																)
															"
															fill="none"
															height="20"
															viewBox="0 0 20 20"
															width="20"
															xmlns="http://www.w3.org/2000/svg"
														>
															<path
																clip-rule="evenodd"
																d="M15 5H2.5C1.80964 5 1.25 5.55964 1.25 6.25V16.25L4.55806 13.3081C4.76872 13.0974 5.0988 13.0647 5.34669 13.23L8.67036 15.4458L13.3081 10.8081C13.4983 10.6179 13.7889 10.5707 14.0295 10.691L16.25 13.125V6.25C16.25 5.55964 15.6904 5 15 5ZM2.5 3.75C1.11929 3.75 0 4.86929 0 6.25V16.25C0 17.6307 1.11929 18.75 2.5 18.75H15C16.3807 18.75 17.5 17.6307 17.5 16.25V6.25C17.5 4.86929 16.3807 3.75 15 3.75H2.5ZM7.5 9.375C7.5 10.4105 6.66053 11.25 5.625 11.25C4.58947 11.25 3.75 10.4105 3.75 9.375C3.75 8.33947 4.58947 7.5 5.625 7.5C6.66053 7.5 7.5 8.33947 7.5 9.375Z"
																fill="#94A3B8"
																fill-rule="evenodd"
															/>
															<path
																clip-rule="evenodd"
																d="M4.5 2.25H18C18.5523 2.25 19 2.69772 19 3.25V14.25C19 14.8023 18.5523 15.25 18 15.25H17.5V16.25H18C19.1046 16.25 20 15.3546 20 14.25V3.25C20 2.14543 19.1046 1.25 18 1.25H4.5C3.39543 1.25 2.5 2.14543 2.5 3.25V3.75H3.5V3.25C3.5 2.69772 3.94772 2.25 4.5 2.25Z"
																fill="#94A3B8"
																fill-rule="evenodd"
															/>
														</svg>
													</td>
													<td>
														<div>
															<div
																class="w-60 whitespace-normal mb-1"
															>
																{{
																	assessment?.note
																}}
															</div>
															<div
																v-if="
																	assessment.repeat_in_next_lesson
																"
																class="py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit shadow-input"
															>
																<svg
																	fill="none"
																	height="14"
																	viewBox="0 0 14 14"
																	width="14"
																	xmlns="http://www.w3.org/2000/svg"
																>
																	<path
																		d="M10.0903 6.125H13.5312C13.7166 6.125 13.818 6.34131 13.6992 6.48379L11.9788 8.54834C11.8913 8.65329 11.7301 8.65329 11.6427 8.54834L9.92221 6.48379C9.80348 6.34131 9.9048 6.125 10.0903 6.125Z"
																		fill="#344256"
																	/>
																	<path
																		d="M0.465262 7.875H3.90618C4.09165 7.875 4.19296 7.65869 4.07423 7.51621L2.35377 5.45166C2.26631 5.34671 2.10513 5.34671 2.01767 5.45166L0.297213 7.51621C0.178482 7.65869 0.279798 7.875 0.465262 7.875Z"
																		fill="#344256"
																	/>
																	<path
																		clip-rule="evenodd"
																		d="M6.99822 2.625C5.63979 2.625 4.42622 3.2436 3.62307 4.21609C3.46921 4.40239 3.19345 4.42869 3.00715 4.27483C2.82084 4.12097 2.79454 3.84521 2.94841 3.65891C3.91065 2.49377 5.36776 1.75 6.99822 1.75C9.57221 1.75 11.7127 3.60194 12.1617 6.04596C12.1665 6.07224 12.1711 6.09859 12.1756 6.125H11.2858C10.8807 4.12806 9.11452 2.625 6.99822 2.625ZM2.71065 7.875C3.11579 9.87194 4.88192 11.375 6.99822 11.375C8.35665 11.375 9.57023 10.7564 10.3734 9.78391C10.5272 9.59761 10.803 9.57131 10.9893 9.72517C11.1756 9.87903 11.2019 10.1548 11.048 10.3411C10.0858 11.5062 8.62868 12.25 6.99822 12.25C4.42423 12.25 2.2837 10.3981 1.83477 7.95404C1.82995 7.92776 1.82531 7.90141 1.82088 7.875H2.71065Z"
																		fill="#344256"
																		fill-rule="evenodd"
																	/>
																</svg>
															</div>
														</div>
													</td>
												</tr>
											</tbody>
										</table>
									</div>
								</div>
							</div>
							<div>
								<div
									v-for="assessment in ass?.assessments"
									:key="assessment.id"
									class="shadow-sm rounded-lg overflow-hidden md:hidden mb-4 bg-white"
									@click="
										$router.push(
											`/goal/${student.id}/${assessment.goal_id}`
										)
									"
								>
									<div
										class="font-semibold text-neutral-600 p-4"
									>
										<div>
											{{ assessment?.goal?.name }}
										</div>
										<div class="flex items-center">
											<div
												v-if="
													assessment?.goal?.display_source
												"
												class="mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input"
												style="font-size: 10px"
											>
												{{
													assessment?.goal
														?.display_source
												}}
											</div>
											<div
												v-if="assessment?.goal?.state"
												class="mt-1 py-0.5 px-2.5 rounded-full bg-neutral-200 text-neutral-700 h-fit w-fit whitespace-nowrap font-semibold shadow-input"
												style="font-size: 10px"
											>
												{{
													$filters.sourceMap(
														assessment?.goal?.state,
														assessment?.goal
															.editable
													)
												}}
											</div>
											<template
												v-if="
													assessment?.goal
														?.assistance_levels
												"
											>
												<div
													v-for="ass in assessment
														?.goal
														?.assistance_levels"
													:key="ass"
												>
													<div
														class="mt-1 py-0.5 px-2.5 rounded-full bg-pink-100 whitespace-nowrap text-neutral-700 h-fit w-fit font-semibold shadow-input"
														style="font-size: 10px"
													>
														{{ ass }}
													</div>
												</div>
											</template>
										</div>
									</div>
									<div class="p-4 border-t border-orange-100">
										<div
											v-if="assessment?.activities_desc"
											class="uppercase font-semibold text-neutral-400"
										>
											Hoạt động
										</div>
										<div>
											<div
												v-if="assessment.activities"
												class="w-60 whitespace-normal"
											>
												<div
													v-for="a in assessment.activities"
													:key="a.id"
													class="mb-2"
												>
													{{ a.name }}
												</div>
											</div>
										</div>
										<div
											v-if="assessment?.note"
											class="mt-4 uppercase font-semibold text-neutral-400"
										>
											Nhận xét buổi học
										</div>
										<div>
											{{ assessment?.note }}
										</div>
										<div
											class="mt-4 uppercase font-semibold text-neutral-400"
										>
											Kết quả
										</div>
										<div
											:style="{
												background: $filters.tagResult(
													assessment?.result
												)?.background,
												color: $filters.tagResult(
													assessment?.result
												)?.color,
											}"
											class="my-2 py-0.5 px-2.5 rounded-full text-neutral-700 h-fit w-fit font-semibold text-xs shadow-input"
										>
											{{ assessment?.result }}
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</div>
				<!-- -->

				<!-- Tab = 1 -->
				<div
					v-if="
						report.key === 'day_care_report' &&
						report.data?.id &&
						tab === index
					"
				>
					<div>
						<div class="mt-10">
							<div
								class="bg-white shadow-sm rounded-2xl overflow-hidden"
							>
								<div
									class="bg-orange-50 p-4 px-6 font-semibold text-lg text-gray-700"
								>
									Báo cáo bán trú
								</div>
								<div class="p-4 px-6">
									<div
										class="flex items-center justify-between flex-nowrap mb-2 md-down:flex-col md-down:items-start"
									>
										<div v-if="report.data?.date">
											{{
												$filters.getDay(
													report.data?.date
												)
											}}
											-
											{{
												$filters.formatDate2(
													report.data?.date
												)
											}}
										</div>
										<router-link
											:to="`/record/employee/${report.data?.submitted_by_staff?.id}`"
										>
											<div
												v-if="
													report.data
														?.submitted_by_staff
												"
											>
												{{
													$filters.terminology(
														'teacher'
													)
												}}
												<span
													class="font-semibold text-blue-700"
													>{{
														report.data
															?.submitted_by_staff
															?.name
													}}</span
												>
											</div>
										</router-link>
									</div>
									<div
										class="flex items-center justify-between flex-nowrap mb-2 md-down:flex-col md-down:items-start"
									>
										<div>
											<div v-if="report.data?.date">
												{{
													report.data.session
														?.display_start_slot
												}}
												<span
													v-if="
														report.data.session
															?.display_end_slot
													"
												>
													-
													{{
														report.data.session
															?.display_end_slot
													}}
												</span>
											</div>
										</div>
										<router-link
											v-if="report.data?.day_care_class"
											to="/setup-center/boarding"
										>
											<div>
												Lớp bán trú
												<span
													class="font-semibold text-blue-700"
													>{{
														report.data
															?.day_care_class
															?.name
													}}</span
												>
											</div>
										</router-link>
									</div>
								</div>
							</div>
						</div>
						<div
							class="mt-10 p-6 bg-white shadow-sm rounded-2xl"
							v-if="
								flagCheck2() &&
								(report?.data?.checkin ||
									report?.data?.checkout)
							"
						>
							<div class="font-semibold text-neutral-600 mb-6">
								Điểm danh
							</div>
							<div class="flex w-full gap-8 md-down:flex-col">
								<div
									class="image-block w-full min-w-0 flex-1"
									v-if="report?.data?.checkin"
								>
									<div class="w-full" style="height: 420px">
										<img
											@click="viewImage(report.data, 0)"
											v-if="report?.data?.checkin?.media"
											class="w-full h-full rounded-lg object-cover"
											:src="
												report?.data?.checkin?.media
													?.asset_url
											"
											alt=""
										/>
										<img
											v-else
											class="w-full h-full object-cover rounded-lg"
											src="@/assets/images/illustrations/checkin.png"
											alt=""
										/>
									</div>
									<div
										class="mt-2 flex items-center justify-between gap-6"
									>
										<div class="flex items-center gap-1">
											<img
												class="w-5 h-5"
												src="@/assets/images/icons/checkin.png"
												alt=""
											/>
											<div
												class="text-neutral-700 font-semibold"
											>
												{{
													report?.data?.checkin
														?.display_media_timestamp ||
													report?.data?.checkin
														?.display_time
												}}
											</div>
										</div>
										<div
											class="text-neutral-700 text-right"
											v-if="
												report?.data?.checkin?.sent_at
											"
										>
											<span class="text-blue-600">{{
												report?.data?.checkin
													?.sent_by_staff?.name
											}}</span>
											đã gửi tới PH
											{{
												$filters.formatDateTime(
													report?.data?.checkin
														?.sent_at
												)
											}}
										</div>
									</div>
								</div>
								<div
									class="image-block w-full min-w-0 flex-1"
									v-if="report?.data?.checkout"
								>
									<div class="w-full" style="height: 420px">
										<img
											@click="viewImage(report.data, 1)"
											v-if="report?.data?.checkout?.media"
											class="w-full h-full rounded-lg object-cover cursor-pointer"
											:src="
												report?.data?.checkout?.media
													?.asset_url
											"
											alt=""
										/>
										<img
											v-else
											class="w-full h-full object-cover rounded-lg"
											src="@/assets/images/illustrations/checkout.png"
											alt=""
										/>
									</div>
									<div
										class="mt-2 flex items-center justify-between gap-6"
									>
										<div class="flex items-center gap-1">
											<img
												class="w-5 h-5"
												src="@/assets/images/icons/checkout.png"
												alt=""
											/>
											<div
												class="text-neutral-700 font-semibold"
											>
												{{
													report?.data?.checkout
														?.display_media_timestamp ||
													report?.data?.checkout
														?.display_time
												}}
											</div>
										</div>
										<div
											class="text-neutral-700"
											v-if="
												report?.data?.checkout?.sent_at
											"
										>
											<span class="text-blue-600">{{
												report?.data?.checkout
													?.sent_by_staff?.name
											}}</span>
											đã gửi tới PH
											{{
												$filters.formatDateTime(
													report?.data?.checkout
														?.sent_at
												)
											}}
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="mt-10">
							<div class="bg-white shadow-sm rounded-2xl">
								<div class="font-semibold text-neutral-600 p-6">
									Nhận xét chung
								</div>
								<div
									class="p-6 border-t border-orange-100 grid md-down:grid-cols-1 lg:grid-cols-2 2xl:grid-cols-4 gap-4"
								>
									<div class="flex items-center">
										<img
											alt=""
											height="48"
											src="@/assets/images/illustrations/nk.png"
											width="48"
										/>
										<div class="ml-4">
											<div
												class="font-semibold text-neutral-700"
											>
												Sức khoẻ
											</div>
											<div>
												{{
													report.data
														?.translated_day_care_health
												}}
											</div>
										</div>
									</div>
									<div class="flex items-center">
										<img
											v-if="enabledMenu"
											alt=""
											height="48"
											src="@/assets/images/illustrations/meals.png"
											width="48"
										/>
										<img
											v-else
											alt=""
											height="48"
											src="@/assets/images/illustrations/milk.png"
											width="48"
										/>
										<div class="ml-4 min-w-0 flex-1">
											<div
												class="font-semibold text-neutral-700"
											>
												Ăn uống
											</div>
											<div v-if="enabledMenu">
												<div
													class="flex items-start gap-2 min-w-0"
													v-for="item in report.data
														.day_care_eats"
													:key="item.id"
												>
													<Popper
														:arrow="true"
														hover
														placement="top"
													>
														<div
															class="cursor-pointer shrink-0 pt-1"
														>
															<img
																class="block h-4 w-4 shrink-0"
																src="@/assets/images/icons/info-circle-line.png"
																alt=""
																width="16"
																height="16"
															/>
														</div>
														<template #content>
															<div
																class="max-w-lg text-gray-600"
															>
																<div
																	class="font-semibold"
																>
																	{{
																		item.meal_name
																	}}
																</div>
																<div
																	v-for="(
																		meal,
																		index
																	) in item.menu_item_dishes"
																	:key="index"
																>
																	{{ meal }}
																</div>
															</div>
														</template>
													</Popper>
													<div
														class="min-w-0 flex-1 break-words text-neutral-700"
													>
														{{ item.meal_name }}:
														<span
															:class="
																item.translated_day_care_eat ===
																'không ăn'
																	? 'text-red-600'
																	: ''
															"
															>Học sinh
															{{
																item.translated_day_care_eat
															}}</span
														>
													</div>
												</div>
											</div>
											<div
												v-else
												:style="
													report.data.day_care_eat ===
													'none'
														? 'color: #DB5A41'
														: ''
												"
											>
												{{
													report.data
														?.translated_day_care_eat
												}}
											</div>
										</div>
									</div>
									<div class="flex items-center">
										<img
											alt=""
											height="48"
											src="@/assets/images/illustrations/moon.png"
											width="48"
										/>
										<div
											:style="
												report.data.day_care_sleep ===
												'none'
													? 'color: #DB5A41'
													: ''
											"
											class="ml-4"
										>
											<div
												class="font-semibold text-neutral-700"
											>
												Giấc ngủ
											</div>
											<div>
												{{
													report.data
														?.translated_day_care_sleep
												}}
											</div>
										</div>
									</div>
									<div class="flex items-center w-full">
										<img
											alt=""
											height="48"
											src="@/assets/images/illustrations/tisue.png"
											width="48"
										/>
										<div class="ml-4 w-full">
											<div
												class="font-semibold text-neutral-700"
											>
												Vệ sinh
											</div>
											<div
												class="flex justify-between w-full"
											>
												<div
													class="mr-4 whitespace-nowrap"
												>
													Vệ sinh nhẹ
												</div>
												<div>
													{{
														report.data
															?.translated_day_care_pee_pee
													}}
													lần
												</div>
											</div>
											<div
												class="flex justify-between w-full"
											>
												<div
													class="mr-4 whitespace-nowrap"
												>
													Vệ sinh nặng
												</div>
												<div class="text-capitalize">
													{{
														report.data
															?.translated_day_care_poo_poo
													}}
													lần
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div
							class="mt-10 grid md-down:grid-cols-1 grid-cols-2 gap-8"
						>
							<div
								class="bg-white shadow-sm rounded-2xl text-center"
							>
								<div class="font-semibold text-neutral-600 p-6">
									Kết quả buổi học
								</div>
								<div
									class="p-6 border-t border-orange-100 flex items-center justify-center flex-col"
								>
									<Rating
										:rating="
											report.data?.day_care_scale || 0
										"
										class="max-w-min py-6"
									/>
								</div>
							</div>
							<div
								class="bg-white shadow-sm rounded-2xl text-center"
								v-if="report.data?.emotion_scale && flagCheck()"
							>
								<div class="font-semibold text-neutral-600 p-6">
									Nhiệt kế cảm xúc
								</div>
								<div
									class="text-neutral-700 p-6 border-t border-orange-100 flex items-center justify-center flex-col"
								>
									<img
										v-if="report.data?.emotion_scale"
										:src="
											require(`@/assets/images/emoji/${
												$filters.emoji(
													report.data.emotion_scale +
														''
												).emoji
											}`)
										"
										alt=""
										height="120"
										width="120"
									/>
									<div
										class="mt-6"
										v-if="
											report.data?.display_emotion_scale
										"
									>
										Học sinh
										{{ report.data?.display_emotion_scale }}
									</div>
								</div>
							</div>
							<div
								class="bg-white shadow-sm rounded-2xl text-center"
								v-if="report.data?.day_care_note"
							>
								<div class="font-semibold text-neutral-600 p-6">
									Nhận xét của giáo viên
								</div>
								<div
									class="text-neutral-700 p-6 border-t border-orange-100"
									v-html="report.data?.day_care_note"
								></div>
							</div>
							<div
								v-if="
									report.data.day_care_activities &&
									report.data.day_care_activities.length > 0
								"
								class="bg-white shadow-sm rounded-2xl"
							>
								<div class="font-semibold text-neutral-600 p-6">
									Hoạt động
								</div>
								<div
									class="p-6 border-t border-orange-100 pl-14"
								>
									<ul class="list-disc">
										<li
											v-for="a in report.data
												.day_care_activities"
											:key="a.id"
											class="mb-2"
										>
											{{ a.name }}
										</li>
									</ul>
								</div>
							</div>
						</div>
						<div
							class="relative mt-10"
							v-if="report.data?.day_care_media?.length > 0"
						>
							<div
								class="absolute inset-0 flex items-center"
								aria-hidden="true"
							>
								<div
									class="w-full border-t border-neutral-300"
								/>
							</div>
							<div class="relative flex justify-center">
								<div
									class="bg-body px-2 text-neutral-600 font-semibold whitespace-nowrap flex flex-nowrap items-center text-2xl justify-center gap-6"
								>
									<div>Album buổi học</div>
								</div>
							</div>
						</div>
						<div class="flex items-center gap-2 flex-wrap mt-4">
							<Popper
								:arrow="true"
								hover
								placement="top"
								v-for="(media, index) in report.data
									?.day_care_media"
								:key="media.id"
								style="width: calc(20% - 0.5rem)"
							>
								<template #content>
									<div class="max-w-lg text-gray-600">
										<div
											v-for="student in media.tagged_students"
											:key="student.id"
										>
											<div class="flex items-center">
												<div class="relative">
													<img
														v-if="
															student
																?.profile_photo
																?.w200
														"
														:src="
															student
																?.profile_photo
																?.w200
														"
														alt=""
														class="shadow-sm inline-block h-6 w-6 rounded-full"
													/>
													<span
														v-else
														:style="{
															background:
																student
																	?.profile_photo
																	?.default
																	?.color,
														}"
														class="inline-flex items-center justify-center h-6 w-6 rounded-full"
													>
														<span
															class="font-medium leading-none text-white text-xs"
															>{{
																student
																	?.profile_photo
																	?.default
																	?.initial
															}}</span
														>
													</span>
												</div>
												<div
													class="ml-4 text-orange-600 font-semibold flex-1"
												>
													{{ student?.name }}
												</div>
											</div>
										</div>
									</div>
								</template>
								<div
									class="relative cursor-pointer w-full"
									@click="
										openMediaPopup(
											index,
											report.data?.day_care_media
										)
									"
								>
									<img
										:src="media.medium?.asset_url"
										alt=""
										class="object-cover rounded-lg w-full"
										style="height: 200px"
									/>
									<div
										class="absolute bottom-2 left-2 text-white flex items-center gap-1"
									>
										<img
											src="@/assets/images/icons/person.png"
											alt=""
											width="16"
											height="16"
										/>
										<div>
											{{ media.tagged_students_count }}/{{
												media.total_students_count
											}}
										</div>
									</div>
								</div>
							</Popper>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script  setup>
import { computed, onMounted, ref } from 'vue';
import DaIcon from '@/components/elements/daIcon/DaIcon.vue';
import Rating from '@/components/elements/rating/Rating.vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import DaModalFrame from '@/components/common/daModalFrame/DaModalFrame.vue';
import CopyModal from '@/views/report/features/copyModal/CopyModal.vue';
import { dayCare } from '@/features/lessonReport/dayCare';
import Loading from '@/components/common/Loading.vue';
import { _GET_DATE_2 } from '@/helper/formatDate';
import { _MONTH_DIFF } from '@/helper/monthDiff';
import Popper from 'vue3-popper';
import ViewPhoto from '@/components/common/ViewPhoto';
import { FLAG_CHECK } from '@/helper/flagCheck';
import { isLitePackage } from '@/helper/packageTier';

const route = useRoute();
const router = useRouter();
const store = useStore();
let count = ref({
	goal: 0,
	skill: 0,
});
let org = ref({});
let student = ref({});
let assessment_result = ref([]);
let series = ref([]);
let dataOfReport = ref([]);
let chartData = ref([]);

const id = computed(() => route.params.id);
const student_id = computed(() => route.query.student_id);
const path = ref('');
const modalIsOpen = ref(false);
const isLoading = ref(true);
const enabledMenu = ref(false);
const chartOptions = ref({
	dataLabels: {
		enabled: false,
	},
	colors: ['#7AD2C6', '#93BF56', '#F8BB54', '#F47C7C', '#E5E7EB'],
	labels: [
		'Đạt 80 - 100%',
		'Đạt 55 - 75%',
		'Đạt 30 - 50%',
		'Đạt 5 - 25%',
		'X',
	],
	tooltip: {
		fillSeriesColor: true,
		y: {
			formatter: function (value) {
				return value + ' mục tiêu';
			},
		},
	},
	legend: {
		show: false,
	},
	stroke: {
		lineCap: 'round',
	},
});
const is_old_data = computed(() => route.query.is_old_data);
function closeShare() {
	modalIsOpen.value = false;
	path.value = '';
}

const oldPayload = ref({
	'x-cross': route.query.org_id,
});
const isLitePackageValue = computed(() => isLitePackage(store.state.profile));
const imageShow = ref(false);
const photosIndex = ref(0);
const photos = ref([]);

function viewImage(data, index) {
	imageShow.value = true;
	photosIndex.value = index;
	photos.value = [
		{ asset_url: data?.checkin?.media?.asset_url || '' },
		{ asset_url: data?.checkout?.media?.asset_url || '' },
	];
}

function openMediaPopup(index, media) {
	imageShow.value = true;
	photosIndex.value = index;
	photos.value = media.map((item) => ({
		asset_url: item.medium?.asset_url,
		tagged_students: item.tagged_students,
		tagged_students_count: item.tagged_students_count,
		total_students_count: item.total_students_count,
		note: item.note,
	}));
}
async function fetchLesson() {
	const res = await dayCare(
		String(id.value),
		String(student_id.value),
		is_old_data.value ? oldPayload.value : null
	);

	if (res?.org) {
		org.value = res?.org;
	}

	if (res?.student) {
		student.value = res?.student;
	}
	enabledMenu.value = res?.enabled_menu;

	res?.data.forEach((item) => {
		dataOfReport.value.push({
			key: item?.data?.type || item?.type,
			data: item?.data || item,
		});

		tab.value = dataOfReport.value.findIndex(
			(d) =>
				d?.data?.data?.type === 'day_care_report' ||
				d?.data?.type === 'day_care_report'
		);

		if (item?.data?.type === 'lesson_report') {
			count.value = item?.count;

			if (item?.stats?.assessment_result) {
				assessment_result.value = item?.stats?.assessment_result;
				let a = [];
				let count = 0;
				assessment_result.value.forEach((item) => {
					if (
						item.name === 'Từ chối' ||
						item.name === 'Không có cơ hội' ||
						item.name === 'Không hợp tác'
					) {
						count += item?.value;
					} else {
						a.push(item);
					}
				});
				a.push({
					name: 'X',
					value: count,
				});
				series.value = a.map((item) => {
					return item.value;
				});
			}
			chartData.value.push({
				assessment_result: assessment_result,
				series: series,
			});
		} else {
			chartData.value.push(null);
		}
	});

	isLoading.value = false;
}

const tab = ref(0);

function timeLearning(session) {
	return session && session?.display_start_slot
		? `${session?.display_start_slot} - ${session?.display_end_slot}`
		: '';
}

function haveMedia(media, goal_id) {
	const result = media.find((item) => item.goal_id == goal_id);
	return !!result;
}

onMounted(() => window.scrollTo(0, 0));
fetchLesson();

const dateData = computed(() => {
	const join_date = route.query.join_date;
	const left_date = route.query.left_date;
	if (!join_date) {
		return '';
	}
	return `${_GET_DATE_2(join_date)} - ${
		left_date ? _GET_DATE_2(left_date) : 'Hiện tại'
	} | Đã học ${_MONTH_DIFF(join_date, left_date)} tháng`;
});

function exit() {
	const new_id = route.query.new_id;
	const r = router.resolve({
		path: `/record/student/${new_id}/staff-list`,
	});
	window.location.assign(r.href);
}

const flagCheck = () => {
	return FLAG_CHECK('DAYCARE_EMOTIONS');
};
const flagCheck2 = () => {
	return FLAG_CHECK('DAYCARE_ATTENDANCE');
};
</script>
